let AbstractExporter = require('../../io/export/abstractExporter');

/**
 * Класс GeoJsonExporter
 * @extends AbstractExporter
 */
class GeoJsonExporter extends AbstractExporter {
  constructor(params) {
    super(params);
  }

  serialize(features) {
    let data = super.serialize(features);
    return data;
  }
}

module.exports = GeoJsonExporter;